import React from 'react';
import styled from 'styled-components';
import { LogoutButton } from '@prosolve/common-components-ui'
import useFetch from '../hooks/useFetch';
import { assetTheme as t } from './assetTheme';

const Wrapper = styled.div`
  display: flex;
  height: 39px;
  padding: 0px 20px;
  align-items: center;
  background: ${t.surface};
  border-bottom: 1px solid ${t.borderStrong};
  font-family: ${t.fontFamily};
`

const Title = styled.div`
  color: ${t.text};
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -.01em;
`

export default () => {
  const fetch = useFetch();

  return (
    <Wrapper>
      <Title>{'Asset Manager'}</Title>
      <div style={{ flex: 1 }}>&nbsp;</div>
      <LogoutButton fetch={fetch} stayOnPath={true} />
    </Wrapper>
  )
}
